const childrenReducer = (state = null, action) => {
    switch (action.type) {
        case 'ACTIVE_STUDENT':
            return action.data
        case 'SIGN_OUT':
            return null
        case 'RESET':
            return null
        default:
            return state
    }
}

export default childrenReducer
